<template>
  <content-page>
    <div class="row">
      <div class="col-lg-12">
        <h1>OP'N privatlivspolitik</h1>
        <p class="lead">OP'N indgår som serviceydelse i Generaxion A/S. Privatlivspolitikken her vedrører brugen af persondata i OP'N og den data der indsamles ved brugen af OP'N servicen.</p>
        <p>
            <strong>Emner:</strong>
            <br>
            <ol>
                <li>Vores service</li>
                <li>Hvilke data indsamler vi? </li>
                <li>Hvordan bruger vi dine informationer?</li>
                <li>Dine rettigheder ift. den information vi har på dig </li>
                <li>Hvem har adgang til dine informationer? </li>
                <li>Hvordan er din data beskyttet? </li>
                <li>Hvor længe opbevares dine informationer? </li>
                <li>Cookies</li>
                <li>GDPR</li>
                <li>Dataansvarlig</li>
            </ol>
        </p>
        <h2>Vores service</h2>
        <p>OP'N tilbyder et dashboard hvorfra data fra tilknyttede sociale medier, søgemaskiner m. fl. kan præsenteres til afrapporterings- og analyseformål.</p>
        <p>Enhver indsamling, brug og håndtering af personlig information fra tilknyttede kanaler i OP'N følger disses respektive privatlivspolitikker og betingelser.</p>
        <p>OP'N muliggøre forbindelse af 3. parts services, herunder applikationer, som kan tilknyttes og vises i dashboarded. Indsamling af dine informationer i relation til disse 3. parts services er håndteret og følger 3. parts privatlivspoilitikker og betingelser. OP'N er ikke ansvarlige for 3. parts service, databehandling eller lign. </p>
        <p>Herfra også omtalt som ”servicen”.</p>
        <h2>Hvilke data indsamler vi?</h2>
        <p>OP'N indsamler følgende information ifm. din brug af vores service.</p>
        <h4>Kontoinformation</h4>
        <p>
            <ul>
                <li>Dine kontakt- og profiloplysninger herunder navn, e-mail, telefonnummer, organisationsnavn, CVR, domæne URL</li>
                <li>Vi kan også indsamle denne information igennem social login services som Google, Facebook og Microsoft</li>
            </ul>
        </p>
        <h4>Indhold</h4>
        <p>
            <ul>
                <li>Dine social profile information for sociale netværk, hvis disse er brugt til at forbinde til vores service. </li>
                <li>En adresse, hvis du vælger at dele denne information.</li>
            </ul>
        </p>
        <h4>Log-, brugs- og supportdata</h4>
        <p>
            <ul>
                <li>Log data kan inkluderer din IP adresse, browser type og indstillinger, din enhedsinformation, dato og tidspunkt for brug af servicen, information om browser konfiguration, sprog præference, unikke identifikationer og cookies.</li>
            </ul>
        </p>
        <h4>Brug af hjemmesiden</h4>
        <p>Når du anvender vores hjemmeside app.opnx.dk indsamler vi følgende informationer, som indsamles automatisk. </p>
        <p>OP'N anvender cookies og lignende sporingsteknologier så som, pixels og tokens, til at muliggøre servicen. Disse er beskrevet i sektionen cookies.</p>
        <h2>Hvordan bruger vi dine informationer?</h2>
        <p>Vi bruger dine informationer til følgende formål:</p>
        <h4>Til at tilbyde og sikre vores service</h4>
        <p>
            <ul>
                <li>Vi har brug for at identificere og bekræfte vores brugere for at sikre, eksempelvis, at det kun er autoriserede brugere som er i stand til at bruge vores service.</li>
                <li>Vi bruger informationen du angiver ifm. login til servicen, samt for at kunne kontakte dig ifm. support af servicen, samt til at håndtere din konto. </li>
                <li>Vi bruger logging og anden data, såsom generel lokation, f. eks. IP adresse af din browser og enhed, til at hjælpe os med at håndtere performance, sikkerhed og stabilitet på servicen.</li>
                <li>Vi analysere brugen af servicen, support forespørgsler m. fl. til at hjælpe os til at forstå brugen af servicen med det formål at tilbyde løbende forbedringer og optimeringer til servicen.</li>
            </ul>
        </p>
        <h4>Kommunikation med dig</h4>
        <p>
            <ul>
                <li>Vi bruger dine kontaktinformationer til at tage kontakt til dig i tilfælde hvor direkte kontakt til vores support er nødvendig for at afhjælpe et teknisk problem.</li>
                <li>Ligeledes vil du, i kraft af din brug af servicen, modtager månedlige status- og statistikrapporter som en del af servicen til den e-mail som er angivet</li>
                <li>Afslutningsvis, kan dine kontaktinformationer bliver brugt til markedsføringsformål for servicen og Generaxion A/S nyhedsbreve, marketing automation o. lign.</li>
            </ul>
        </p>
        <h4>Forbedring af vores hjemmeside og applikationer</h4>
        <p>
            <ul>
                <li>Vi bruger informationer vi modtager fra dig til at forstå brugsmønstre og andre aktiviteter på vores hjemmeside og applikationer, så vi kan diagnosticere problemer og foretage forbedringer, herunder styrker brugerfladen og sikkerhed</li>
            </ul>
        </p>
        <h2>Dine rettigheder ift. den information vi har på dig</h2>
        <p>Følgende kortlægger dine rettigheder ift. den information vi har på dig ifm. brug af vores service. </p>
        <h4>Service information</h4>
        <p>Når du bruger vores service, må du tilgå, opdatere og rette det meste af dine kontoinformationer ved at logge ind på din konto og redigere din profil. </p>
        <p>Hvis dine ønskede ændringer ikke kan udføres ved at logge ind på din konto, så som at tilgå mere information eller slette information om dig, bedes du kontakte din Generaxion A/S Strategy Specialist eller Generaxion A/S på <a href="mailto:info@generaxion.dk">info@generaxion.dk</a>. Vi kan være nødsaget til at tilbageholde noget information omkring dig så længe du anvender vores service, for at du kan anvende vores service.</p>
        <p>Du kan kontakte Generaxion A/S for generelle henvendelser og eller support vedr. din servicekonto. </p>
        <h4>Marketing emails, markedsføring og brug af hjemmeside</h4>
        <p>Ved brug af vores service accepterer du at Generaxion A/S må kontakte dig med markedsføringsrelateret indhold. </p>
        <h2>Hvem har adgang til dine informationer?</h2>
        <p>OP'N udlejer eller sælger ikke dine informationer. Vi begrænser adgang til dine informationer til autoriserede medarbejdere og vi deler ikke dine informationer med 3. part foruden i situationer som beskrevet herunder.</p>
        <h4>Medarbejdere og autoriserede underleverandører</h4>
        <p>Vores medarbejdere og autoriserede underleverandører kan have behov for at tilgå information om dig når de skal udføre deres arbejde. F. eks. kan support have behov for at tilgå din konto for at validere din identitet samt svare på support- eller generelle spørgsmål; I tilfælde hvor du, foruden brug af vores service, også er kunde hos Generaxion A/S, vil Generaxions medarbejdere kunne have behov for at tilgå jeres konto for at foretage afrapportering og optimering af jeres markedsføringsaktiviteter.</p>
        <p>Alle vores medarbejdere og underleverandører påkræves fortrolighed omkring dine data og informationer.</p>
        <h4>Sociale netværk og tredje parts services</h4>
        <p>I de situationer hvor din servicekonto er forbundet til 3. parts serviceydelser, så som sociale netværk, google m. fl, autoriseres adgang til dine informationer for at indhente dataen til dit dashboard på din servicekonto.</p>
        <h2>Hvordan er din data beskyttet?</h2>
        <p>OP'N holder industristandard sikkerhedsforanstaltninger for at beskytte dine data og informationer. Dette inkluderer at sikre at vores medarbejdere modtager den fornødne træning i sikkerhed og privatlivsinformationshåndtering og besidder den fornødne viden og vejledning til at sikre at dine data og informationer beskyttes.</p>
        <p>Vores service er beskyttet af adgangskontrol for at begrænse adgang til dine data og informationer, så disse kun er tilgængelige for de medarbejdere som skal bruge disse til at udføre deres arbejde.</p>
        <p>Vi krypterer data hvor dette er nødvendigt, så din information holdes privat.</p>
        <h2>Hvor længe opbevares dine informationer?</h2>
        <p>Generelt opbevare OP'N dine informationer i det tidsrum hvor din konto er aktiv på vores netværk. </p>
        <p>Vi opbevarer kun dine informationer i det tidsrum det er nødvendigt for at du kan bruge vores service, for statistik formål og for eventuelle juridiske forpligtelser som måtte følge af vores handelsbetingelser.</p>
        <p>Såfremt kontoen lukkes helt slettes din data. Dette kan anmodes ved at kontakte Generaxion A/S på <a href="mailto:info@generaxion.dk">info@generaxion.dk</a>.</p>
        <h2>Cookies</h2>
        <p>Ved brug af OP'N anvendes følgende cookies:</p>
        <p>
            opnx.dk
            <br>
            _cfduid
            <br>
            __mp_opt_in_out_ee7099b894bd6afebe7ad7e0e55185ab
            <br>
            _fbp
            <br>
            _ga
            <br>
            _gat
            <br>
            _gid
            <br>
            mp_ee7099b894bd6afebe7ad7e0e55185ab_mixpanel
        </p>
        <h2>GDPR</h2>
        <p>Alt efter situationen kan OP'N agere data behandler eller data formidler.</p>
        <h4>OP'N som databehandler</h4>
        <p>OP'N fungerer som databehandler når vi:</p>
        <p>
            <ul>
                <li>Indsamler information til opsætning og administration af din servicekonto</li>
                <li>Overvågning af brugen af information på vores website</li>
                <li>Håndtering af kontakt og anden relateret information til at sende marketing, service og anden kommunikation til dig</li>
                <li>Håndtering af supportrelevante og eller generelle service spørgsmål</li>
            </ul>
        </p>
        <h4>Samtykke grundlag for OP'N som databehandler</h4>
        <p>Grundlag for OP'N som databehandler inkluderer:</p>
        <p>
            <ul>
                <li>Ved at bruge vores service giver du samtykke til at vi kan behandle dine informationer og data med det formål at levere den ønskede service.</li>
                <li>Der kan forekomme juridiske forpligtelser som gør det nødvendigt at OP'N behandler dine data.</li>
            </ul>
        </p>
        <h4>Dine rettigheder når OP'N er din databehandler</h4>
        <p>Når OP'N er databehandler er følgende rettigheder gældende for dig</p>
        <p>
            <ul>
                <li>Du er i din fulde ret til at opsige eller slette din servicekonto, hvorved adgang til servicen ikke længere er givet og dine data slettes.</li>
                <li>Du er i din fulde ret til at opsøge mere information om den data og information der opbevares ved brug af servicen.</li>
                <li>Du kan frit ændrer i den data og information vi opbevarer for dig inden for hvad der kan lade sig gøre med standard servicekonto adgang. Skulle du ønske at ændrer information som ikke er muligt med din servicekonto adgang bedes du kontakte OP'N support via Generaxion A/S.</li>
            </ul>
        </p>
        <h4>OP'N som dataformidler</h4>
        <p>
            Hele servicens primære formål er at fungerer som dataformidler, hvor eksterne services så som Facebook API, Google API m.v. hentes og præsenteres for brugeren af OP'N til præsentation og afrapporteringsformål i et samlet dashboard.
        </p>
        <p>Ved brug af servicen kan du frit forbinde til eksterne services, for at indhente dine data til afrapportering. OP'N formidler dataen i det omfang det er muligt, men er ikke ansvarlige for den viste data. Her fungerer servicen udelukkende som formidler.</p>
        <p>Det er hverken OP'Ns eller Generaxion A/S ansvar at sikre at den indhentede data fra tilknyttede eksterne services, eksempelvis fra google analytics api, er indsamlet jf. gældende GDPR lovgivning og brugersamtykke.</p>
        <h2>OP'N Dataansvarlig</h2>
        <p>Servicen OP'N udbydes og drives af:</p>
        <p>Websitet generaxion.dk udbydes og drives af:</p>
        <p>
            <strong>Generaxion</strong>
            <br>
            Sommervej 23A
            <br>
            DK-8210 Aarhus V
            <br><br>
            Cvr nr: 31 18 98 10
            <br>
            Tlfnr : 70 23 10 23
            <br>
            E-mail: info@generaxion.dk
            <br>
            Etableringsår: 2008
        </p>
      </div>
    </div>
  </content-page>
</template>

<script>
import ContentPage from "@/components/ContentPage";

export default {
  components: {
    ContentPage,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/PrivacyPolicy.vue